<template>
  <div id="footer" :class="{ set: checkFooter }">
    <router-link
      v-for="link in footerLinks"
      :key="link.to"
      :to="link.to"
      class="footer-link"
    >
      <img
        :src="getIconPath(link)"
        :alt="link.altText"
      />

      <p :class="{ active: activeLink === link.to }">
        {{ link.altText }}
      </p>
    </router-link>
  </div>
</template>

<script>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

import priceIconOn from "@/assets/images/icon/footer/market-active.png";
import priceIconOff from "@/assets/images/icon/footer/market.png";

import alarmIconOn from "@/assets/images/icon/footer/alert-active.png";
import alarmIconOff from "@/assets/images/icon/footer/alert.png";

import homeIconOn from "@/assets/images/icon/footer/home-active.png";
import homeIconOff from "@/assets/images/icon/footer/home.png";

import boardIconOn from "@/assets/images/icon/footer/briefing-active.png";
import boardIconOff from "@/assets/images/icon/footer/briefing.png";

import userIconOn from "@/assets/images/icon/footer/setting-active.png";
import userIconOff from "@/assets/images/icon/footer/setting.png";

export default {
  name: "Footer",

  setup() {
    const route = useRoute();
    const { t, locale } = useI18n();

    const firstPath = computed(() => {
      return route.path.split("/")[1] || "";
    });

    const subPath = computed(() => {
      return route.path.split("/")[2] || "";
    });

    const activeLink = computed(() => {
      return `/${firstPath.value}`;
    });

    /*
     * locale.value를 참조하므로 언어가 변경될 때
     * footerLinks가 자동으로 다시 계산됩니다.
     */
    const footerLinks = computed(() => {
      // locale을 명시적으로 참조해 언어 변경을 반응형으로 추적
      void locale.value;

      return [
        {
          to: "/price",
          iconOn: priceIconOn,
          iconOff: priceIconOff,
          altText: t("price.market"),
        },
        {
          to: "/board",
          iconOn: boardIconOn,
          iconOff: boardIconOff,
          altText: t("brief.brief"),
        },
        {
          to: "/home",
          iconOn: homeIconOn,
          iconOff: homeIconOff,
          altText: t("common.home"),
        },
        {
          to: "/alarm",
          iconOn: alarmIconOn,
          iconOff: alarmIconOff,
          altText: t("alarm.alarm"),
        },
        {
          to: "/user",
          iconOn: userIconOn,
          iconOff: userIconOff,
          altText: t("common.setting"),
        },
      ];
    });

    const getIconPath = (link) => {
      return activeLink.value === link.to
        ? link.iconOn
        : link.iconOff;
    };

    const hiddenFooterPaths = [
      "member-info",
      "recommend-info",
      "subscribe-info",
      "connect-api",
      "position",
      "setting-general",
      "confirm-ver",
      "plus-coin",
      "alarm-chart",
      "pm-brief",
      "am-brief",
      "notice-detail",
    ];

    const checkFooter = computed(() => {
      return hiddenFooterPaths.includes(subPath.value);
    });

    return {
      footerLinks,
      activeLink,
      getIconPath,
      firstPath,
      subPath,
      checkFooter,
    };
  },
};
</script>

<style>
.set {
  display: none !important;
}
</style>